import {
  Module,
  VuexModule,
  Mutation,
  config,
  Action,
} from "vuex-module-decorators";
import { ICurrency, ITransaction, ITransactionPageInfo } from "../types";

config.rawError = true;

@Module({ namespaced: true })
export default class TransactionsModule extends VuexModule {
  currencies: ICurrency[] = [];
  transactions: ITransaction[] = [];
  transactionPageInfo: ITransactionPageInfo | null = null;

  @Mutation
  setCurrencies(currencies: ICurrency[]) {
    this.currencies = currencies;
  }

  @Mutation
  setTransactions(transactions: ITransaction[]) {
    this.transactions = transactions;
    const totalTrades = transactions.length;

    //To Fix
    // this.context.dispatch('getTotalAmount', transactions);

    let totalUsd = 0;
    let totalNgn = 0;
    for (const transaction of transactions) {
      totalUsd += transaction.amountUSD;
      totalNgn += transaction.amountNGN;
    }
    let transactionInfo = {
      totalNgn,
      totalUsd,
      totalTrades,
    };
    this.transactionPageInfo = transactionInfo;
  }

  @Action
  getTotalAmount(transactions: ITransaction[]): void {
    let totalUsd = 0;
    let totalNgn = 0;
    const totalTrades = transactions.length;
    for (const transaction of transactions) {
      totalUsd += transaction.amountUSD;
      totalNgn += transaction.amountNGN;
    }
    this.context.commit("updateTotalAmount", {
      totalUsd,
      totalNgn,
      totalTrades,
    });
  }

  @Mutation
  updateTotalAmount({
    totalUsd,
    totalNgn,
    totalTrades,
  }: {
    totalUsd: number;
    totalNgn: number;
    totalTrades: number;
  }) {
    let transactionInfo = {
      totalNgn,
      totalUsd,
      totalTrades,
    };
    this.transactionPageInfo = transactionInfo;
  }

  @Mutation
  clear() {
    this.currencies = [];
  }
}
